/**
 * @file 「この端末でいま扱っているまなぶ人」を覚える (localStorage)。
 *
 * @what: 家族ごとに person id を1つ覚える。学習の面のヘッダーで選び直したときに書き、
 *   面を開いたときの既定と、記録シート・復習カードを作る枠・解いた結果のまなぶ人の既定に使う。
 * @why: 覚えないと、読み込み直すたびに先頭の人へ戻る (代表の指摘、2026-09-07)。養育者の独学でも
 *   毎回同じ人を選び直すことになる。サーバに持たせず端末に置くのは、どの人を見ているかが
 *   家族の中の話で、端末ごとに違ってよいためである。
 * @failure: localStorage が使えない端末では覚えない (読みは null なので先頭の人に倒れる)。
 */

const key = (familyId: string) => `study.lastLearner.${familyId}`;

export function readLastLearner(familyId: string): string | null {
  try {
    return window.localStorage.getItem(key(familyId));
  } catch {
    return null;
  }
}

export function writeLastLearner(familyId: string, personId: string): void {
  try {
    window.localStorage.setItem(key(familyId), personId);
  } catch {
    // 覚えられなくても操作には影響しない
  }
}
